import { STATUSES } from '@guuru/chat-common';
import {
  CHAT_FLOW_STEPS,
  getCurrentChat,
  setConnectionError,
  setFlowStep,
} from '@guuru/chat-web';
import { BOTS } from '@guuru/expert-common';
import log from '@guuru/logger-web';

const findCurrentStep = function ({ status, messages, expert }) {
  switch (status) {
    case STATUSES.created:
    case STATUSES.assigned:
      return CHAT_FLOW_STEPS.connectingExpert;
    case STATUSES.open: {
      if (expert?.id !== BOTS.bot.externalId) {
        return CHAT_FLOW_STEPS.chat;
      }

      const lastMessage = messages.edges.at(-1);
      return lastMessage?.node?.type === 'intentSelection'
        ? CHAT_FLOW_STEPS.requestIntentSelection
        : CHAT_FLOW_STEPS.makePrediction;
    }
    case STATUSES.closed:
      return CHAT_FLOW_STEPS.closeChat;
    case STATUSES.rated:
      return CHAT_FLOW_STEPS.rateChat;
    case STATUSES.handover:
    case STATUSES.missed:
      return CHAT_FLOW_STEPS.chatEnd;
    default:
      return null;
  }
};

const shouldUpdateChatFlowStep = (step) => {
  if (!step) return false;

  const { flowStep: currentStep, flowSteps: chatFlowSteps } = getCurrentChat();
  if (
    currentStep === CHAT_FLOW_STEPS.rateBadChat &&
    step === CHAT_FLOW_STEPS.closeChat
  ) {
    return false;
  }
  return (
    chatFlowSteps.indexOf(step) === -1 ||
    chatFlowSteps.indexOf(step) > chatFlowSteps.indexOf(currentStep)
  );
};

export default function (updatedChat) {
  try {
    setConnectionError(false);
    const step = findCurrentStep(updatedChat);
    if (shouldUpdateChatFlowStep(step)) {
      setFlowStep(step);
    }
  } catch (error) {
    log.error(error);
  }
}
